import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import DashboardScreen from ".";
import Empresa from "./gestionar-empresa/empresa";
import ListarEmpresas from "./gestionar-empresa/listar-empresas";
import ModificarEmpresa from "./gestionar-empresa/editar-empresa";
import EventosEmpresaPage from "./gestionar-empresa/eventos-empresa";
import EmpresasCreadasPage from "./gestionar-empresa/empresas-creadas";

const RouterAdministracion = () => {
  const { path } = useRouteMatch();
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}`}>
        <DashboardScreen />
      </Route>

      <Route exact path={`${path}/gestionar-empresa/listar-empresas`}>
        <ListarEmpresas />
      </Route>
      <Route exact path={`${path}/gestionar-empresa/empresa`}>
        <Empresa />
      </Route>
      <Route exact path={`${path}/gestionar-empresa/modificar-empresa`}>
        <ModificarEmpresa />
      </Route>
      <Route exact path={`${path}/gestionar-empresa/eventos-empresa`}>
        <EventosEmpresaPage />
      </Route>
      <Route exact path={`${path}/gestionar-empresa/empresas-creadas`}>
        <EmpresasCreadasPage />
      </Route>

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterAdministracion;
